interface Props {
  size?: number;
  color?: string;
}
const VoucherValueIcon = (props: Props) => {
  const { color, size = 35 } = props;
  return (
    <>
      <svg
        width={35}
        height={35}
        viewBox={`0 0 35 35`}
        fill="none"
        style={{ width: size, height: size }}
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M23.2426 23.2424C28.2339 22.5742 32.0834 18.2991 32.0834 13.125C32.0834 7.48706 27.513 2.91663 21.8751 2.91663C16.7009 2.91663 12.4258 6.76614 11.7576 11.7574M23.3334 21.875C23.3334 27.5129 18.763 32.0833 13.1251 32.0833C7.48718 32.0833 2.91675 27.5129 2.91675 21.875C2.91675 16.237 7.48718 11.6666 13.1251 11.6666C18.763 11.6666 23.3334 16.237 23.3334 21.875Z"
          stroke={color || 'currentColor'}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      {/* <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.5595 10.0595C12.7842 9.76167 14.5 7.8562 14.5 5.55C14.5 3.03711 12.4629 1 9.95 1C7.6438 1 5.73832 2.71579 5.44048 4.94048M10.6 9.45C10.6 11.9629 8.5629 14 6.05 14C3.53711 14 1.5 11.9629 1.5 9.45C1.5 6.9371 3.53711 4.9 6.05 4.9C8.5629 4.9 10.6 6.9371 10.6 9.45Z"
          stroke={color || 'currentColor'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg> */}
    </>
  );
};

export default VoucherValueIcon;
